var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"social-link",attrs:{"target":"_blank","href":_vm.platformUrl,"rel":"noopener"}},[_c('span',[_vm._v(_vm._s(_vm.platformKey))]),_c('Sprite',{attrs:{"name":_vm.platformKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }